import moment from "moment";

import { API_URL, SPOTIFY_API_URL } from "./constants";
import { sendRequest } from "./utils";

/** @type {object} */
let spotifyCredentials;

/**
 * @param  {Object} credentials
 * @returns {boolean}
 */
export const shouldFetchNewCredentials = (credentials) => {
  return (
    !credentials ||
    moment()
      .subtract(credentials.expiresIn, "s")
      .isAfter(credentials.lastUpdate)
  );
};
/**
 * @param  {boolean} [isRetry=false]
 * @returns {Promise<Optional<Object>>}
 */
export const getSpotifyCredentials = async (isRetry) => {
  if (!shouldFetchNewCredentials(spotifyCredentials) && !isRetry) {
    return {
      ok: true,
      data: spotifyCredentials,
    };
  }
  try {
    if (!isRetry) {
      const response = await fetch(`${API_URL}/t`);
      if (response.ok) {
        const credentials = await response.json();
        spotifyCredentials = credentials;
        return {
          ok: true,
          data: credentials,
        };
      } else {
        console.warn("Could not get Spotify client credentials from server");
        throw new Error("Could not get Spotify client credentials from server");
      }
    }
  } catch (error) {
    return {
      ok: false,
      error: {
        message: error.message,
      },
    };
  }
};

/**
 *
 * @param {Object} param0
 * @param {string} param0.path
 * @param {boolean} [param0.expectJson=true]
 * @param {Object} param0.options
 */
export const sendRequestWithCredentials = async ({
  path,
  expectJson = true,
  options: _options,
}) => {
  if (!path) {
    return { ok: false, error: "Need path" };
  }
  const { ok, data: credentials, error } = await getSpotifyCredentials();
  if (!ok) {
    return { ok: false, error };
  }
  const options = {
    method: "GET",
    headers: new Headers({
      Authorization: `Bearer ${credentials.accessToken}`,
    }),
    ..._options,
  };
  return sendRequest({
    url: SPOTIFY_API_URL,
    path,
    expectJson,
    options,
  });
};
